import gql from "graphql-tag";

export default gql`
  query invoiceCustomersReport {
    invoiceCustomersReport {
      fileName
      contentBase64
      totalCount
    }
  }
`;
